<template>
    <v-dialog v-model="dOpenComponent" persistent full-width @keydown.esc="fCerrarVentana()" @keydown.enter="fBuscar()">
        <v-card>
            <!-- cabecera del dialogo -->
            <v-toolbar dark class="datModalTitleContainer">
                <v-toolbar-title>
                    {{ dInformeComponente.nombre }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click="fCerrarVentana()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-dialog v-if="dOpenComponent" v-model="dLoading" hide-overlay persistent width="300">
                <v-card class="datModalTitleContainer" dark>
                    <v-card-text>
                        {{ $t('cargandoContenido') }}
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-form ref="form" lazy-dValidation>
                <v-card-text>
                    <div class="subheading font-weight-bold mt-2 mb-2 px-3">{{ dInformeComponente.descripcion }}</div>
                </v-card-text>
                <!-- Filtro de cabecera -->
                <v-layout row wrap ml-3 mr-3>
                    <v-flex md3 xs12 px-2>
                        <v-menu :ref="dDatosFiltros.fechaIniMenu" lazy v-model="dDatosFiltros.fechaIniMenu"
                            transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                            :close-on-content-click="false">
                            <v-text-field required clearable color="data-colorcorp1" slot="activator"
                                :label="$t('fechaInicial')" v-model="dDatosFiltros.fechaIniString" append-icon="event"
                                readonly @click:clear="fGetFecha(null, 'ini')"></v-text-field>
                            <v-date-picker required :min="dDatosFiltros.fechaMinIni" clearable
                                v-model="dDatosFiltros.fechaIni" no-title scrollable :first-day-of-week="1"
                                locale="es-es" @input="fGetFecha(dDatosFiltros.fechaIni, 'ini')"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex md3 xs12 px-2>
                        <v-menu :ref="dDatosFiltros.fechaFinMenu" lazy v-model="dDatosFiltros.fechaFinMenu"
                            transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                            :close-on-content-click="false">
                            <v-text-field required clearable color="data-colorcorp1" slot="activator"
                                :label="$t('fechaFinal')" v-model="dDatosFiltros.fechaFinString" append-icon="event"
                                readonly @click:clear="fGetFecha(null, 'fin')"></v-text-field>
                            <v-date-picker required :min="dDatosFiltros.fechaMinFin" clearable
                                v-model="dDatosFiltros.fechaFin" no-title scrollable :first-day-of-week="1"
                                locale="es-es" @input="fGetFecha(dDatosFiltros.fechaFin, 'fin')"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex md12 xs12 px-2></v-flex>
                    <v-flex md3 xs12 px-2>
                        <v-text-field v-model="dDatosFiltros.numeroOc" clearable @keydown.enter="fBuscar()"
                            :label="$t('ordenCompra')"></v-text-field>
                    </v-flex>
                    <v-flex md3 xs12 px-2>
                        <v-select v-model="dDatosFiltros.centro" clearable @keydown.enter="fBuscar()"
                            :label="$t('centro')" :items="dCentros"
                            :item-text="item => `${item.centro} - ${item.denominacion}`" item-value="centro"
                            :no-data-text="$t('noResultados')"></v-select>
                    </v-flex>
                    <v-flex md12 xs12 px-2></v-flex>
                    <v-flex md6 xs6 px-2 v-if="dRole === 'ADMIN'">
                        <DatTextFieldCode ref="TablaDeProveedores" :pDataPass="dDataProveedor" @alert="fAlert"
                            @select="fSelectProveedor" @clean="fCleanProveedor"></DatTextFieldCode>
                    </v-flex>
                    <v-flex md6 xs6 px-2 v-if="dRole === 'ADMIN'">
                        <DatTextFieldCode ref="TablaSucursalDeProveedores" :pDataPass="dDataSucursalProveedor"
                            @alert="fAlert" @select="fSelectSucursalProveedor" @clean="fCleanSucursalProveedor">
                        </DatTextFieldCode>
                    </v-flex>
                    <v-flex xs12 text-xs-right>
                        <v-tooltip top>
                            <v-btn slot="activator" @click="fDescargarXlsx" icon>
                                <v-icon color="datSecondary">mdi-file-excel</v-icon>
                            </v-btn>
                            <span>{{ $t('descagarExcel') }}</span>
                        </v-tooltip>
                        <v-btn @click="fBuscar()" class="datSecondaryBtn" small flat tile>
                            {{ $t('buscar') }}
                        </v-btn>
                    </v-flex>
                </v-layout>
                <!-- Cabecera -->
                <v-flex>
                    <v-layout row wrap>
                        <v-flex text-xs-center class="mb-3">
                            <v-data-table item-key="numeroOc" :loading="dLoading" single-expand
                                :no-results-text="this.$t('noResultados')" :no-data-text="this.$t('noResultados')"
                                :rows-per-page-text="$t('numRegPagina')" v-bind:pagination.sync="dPaginationArt"
                                :total-items="dTotalItems" class="tablePedidos"
                                :rows-per-page-items="dRowsPerPageItemsArt" :items="dDatosTabla"
                                :headers="dHeadersTable">
                                <template slot="headers" slot-scope="props">
                                    <tr class="lightPrimaryColorBackground">
                                        <th class="text-xs-center" v-for="header in props.headers" :key="header.key"
                                            :id="header.value"
                                            :class="['column sortable', dPaginationArt.descending ? 'desc' : 'asc', header.value === dPaginationArt.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']"
                                            @click="fCambiaOrden(header, dPaginationArt)">
                                            <v-icon v-if="header.sortable">arrow_upward</v-icon>
                                            {{ header.text }}
                                        </th>
                                    </tr>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <tr :key="props.item.numeroOc">
                                        <td class="text-xs-center ellipsis" @click="fGetDetalleOC(props)">
                                            <v-icon class="cursorPointer" :class="props.expanded ? 'iconRotate' : ''">
                                                arrow_downward
                                            </v-icon>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.centro }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.proveedor }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.sucursal }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.numeroOc }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.fechaOC }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.numAlbaran }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.numTicket }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.agenciaTransporte }}</span>
                                        </td>
                                        <td class="text-xs-center ellipsis">
                                            <span>{{ props.item.matricula }}</span>
                                        </td>

                                    </tr>
                                </template>
                                <template slot="expand" slot-scope="props">
                                    <!-- DETALLE DE OC -->
                                    <v-data-table item-key="itemOC" :headers="dHeadersSubOCTabla"
                                        :items="dSubOCDatosTabla" :loading="dLoading"
                                        :pagination.sync="dPaginationSubOC" :rows-per-page-text="$t('numRegPagina')"
                                        :total-items="dTotalSubOCItems" :rows-per-page-items="dRowsPerPageItemsSubOC"
                                        class="subtitle-2" dense>
                                        <!-- Headers personalizados para la subtabla -->
                                        <template slot="headers" slot-scope="props">
                                            <tr class="lighterPrimaryColorBackground">
                                                <th class="text-xs-center" v-for="header in props.headers"
                                                    :key="header.key" :id="header.value" :class="[
                                                        'column',
                                                        header.value === dPaginationSubOC.sortBy ? (dPaginationSubOC.descending ? 'desc' : 'asc') : '',
                                                        'text-xs-' + header.align,
                                                        header.class
                                                    ]" @click="() => { }">
                                                    {{ header.text }}
                                                </th>
                                            </tr>
                                        </template>

                                        <template slot="items" slot-scope="{ item }">
                                            <!-- Fila principal -->
                                            <tr :key="props.item.itemOC">
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.producto }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.descProducto }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.codigoLer }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.numeroDI }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.cantidad }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.precioArt }}</span>
                                                </td>
                                                <td class="text-xs-center" style="vertical-align: middle">
                                                    <span>{{ item.importeLinea }}</span>
                                                </td>
                                            </tr>

                                            <!-- Fila de observaciones, ocupa todas las columnas -->
                                            <tr :key="item.itemOC + '-obs'">
                                                <td :colspan="dHeadersSubOCTabla.length" class="text-xs-left pl-12"
                                                    style="background-color: #f5f5f5;">
                                                    {{ $t("observaciones") }}: {{ item.observacionesOC }}
                                                </td>

                                            </tr>
                                        </template>
                                    </v-data-table>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>

import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'
import SrvOrdenesCompra from '@/services/srv-ordenes-compra'
import SrvGeneral from '@/services/srv-general'
import XLSX from 'xlsx'

export default {
    components: {
        DatTextFieldCode,
        DatTextFieldCodeSubfield
    },
    props: {
        pInformeComponente: {
            type: Object,
            required: true,
            default: false
        },
        pLimitDate: {
            type: Object,
            required: true,
            default: false
        }
    },
    data() {
        return {
            dOpenComponent: true,
            dInformeComponente: {},
            dRole: '',
            dLimitDate: {},
            dDatosFiltros: {
                centro: ''
            },
            dCentros: [],
            dHeadersTable: [],
            dDatosTabla: [],
            dPaginationSubOC: { 'sortBy': 'producto', 'descending': true, 'rowsPerPage': 5, 'page': 1 },
            dSelectProveedor: { codigo: '', nombre: '' },
            dSelectSucursalProveedor: { codigo: '', nombre: '' },
            currentOrdenCompra: '',
            dTotalSubOCItems: 0,
            dHeadersSubOCTabla: [],
            dSubOCDatosTabla: [],
            dFormatDate: {
                'default': 'DD/MM/YYYY',
                'years': 'YYYY-MM-DD'
            },
            // 
            dFirstSortTable: 0,
            dFirstSortTableSubOC: 0,
            dRowsPerPageItemsArt: [5, 10, 25],
            dRowsPerPageItemsSubOC: [5, 10, 25],
            dTotalItems: 0,
            dLoading: false,
            dPaginationArt: { 'sortBy': 'codigoProveedor', 'descending': false, 'rowsPerPage': 10, 'page': 1 },
            dIsOnPremise: localStorage.getItem('isOnPremise') === 'yes',
            dRequestCliente: { empresa: this.$store.getters.getAutenticacion.empresa },
            dDataProveedor: {},
            dDataSucursalProveedor: {},
        }
    },
    created() {
        this.fIniciarVariables()
        this.dRole = this.pLimitDate.roleUser
    },
    mounted() {
        this.dInformeComponente = this.pInformeComponente
        this.dLimitDate = this.pLimitDate
    },
    methods: {
        fSelectProveedor(item) {
            if (item && item != null) {
                this.dSelectProveedor.codigo = item.codigo
                this.dSelectProveedor.nombre = item.nombre
            }
            this.fCleanSucursalProveedor();
            this.dDataSucursalProveedor.request.codigoProveedor = this.dSelectProveedor.codigo;
        },
        fSelectSucursalProveedor(item) {
            if (item && item != null) {
                this.dSelectSucursalProveedor.codigo = item.codigo
                this.dSelectSucursalProveedor.nombre = item.nombre
            }
        },
        fCleanProveedor() {
            if (this.$refs.TablaDeProveedores !== undefined) {
                this.$refs.TablaDeProveedores.fClean()
            }
            this.dSelectProveedor = []
        },
        fCleanSucursalProveedor() {
            if (this.$refs.TablaSucursalDeProveedores !== undefined) {
                this.$refs.TablaSucursalDeProveedores.fClean()
            }
            this.dSelectSucursalProveedor = []
        },
        fCerrarVentana() {
            this.$emit('close')
        },
        fIniciarVariables() {
            this.dHeadersTable = [
                { key: 'arrow', text: '', align: 'left', value: 'arrow', sortable: true },
                { key: 'centro', text: this.$t('centro'), align: 'left', value: 'centro', sortable: true },
                { key: 'codigoProveedor', text: this.$t('proveedor'), align: 'left', value: 'codigoProveedor', sortable: true },
                { key: 'sucursal', text: this.$t('sucursal'), align: 'left', value: 'sucursal', sortable: true },
                { key: 'numeroOc', text: this.$t('ordenCompra'), align: 'left', value: 'numeroOc', sortable: true },
                { key: 'fechaOC', text: this.$t('fechaOC'), align: 'left', value: 'fechaOC', sortable: true },
                { key: 'numAlbaran', text: this.$t('numAlbaran'), align: 'left', value: 'numAlbaran', sortable: true },
                { key: 'numTicket', text: this.$t('numTicket'), align: 'left', value: 'numTicket', sortable: true },
                { key: 'agenciaTransporte', text: this.$t('agenciaTransporte'), align: 'left', value: 'agenciaTransporte', sortable: true },
                { key: 'matricula', text: this.$t('matricula'), align: 'left', value: 'matricula', sortable: true },
            ]
            this.dHeadersSubOCTabla = [
                { key: 'productos', text: this.$t('productos'), value: 'productos', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'descProducto', text: this.$t('descProducto'), value: 'descProducto', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'codigoLER', text: this.$t('codigoLER'), value: 'codigoLER', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'numeroDI', text: this.$t('numeroDI'), value: 'numeroDI', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'cantidad', text: this.$t('cantidad'), value: 'cantidad', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'precio', text: this.$t('precio'), value: 'precio', align: 'left', class: this.dClass, width: '500px', sortable: true },
                { key: 'importe', text: this.$t('importe'), value: 'importe', align: 'left', class: this.dClass, width: '500px' },
            ]

            this.dDataProveedor = {
                'errorMessages': this.dErrorMsgProveedor,
                'label': 'proveedor',
                'rowsPerPage': 10,
                'headers': [
                    { text: this.$t('proveedor'), align: 'left', value: 'codigo', column: 'codProveedor' },
                    { text: this.$t('nombreProv'), align: 'left', value: 'nombre', column: 'nombreProveedor' }
                ],
                'urlWS': 'lovProv',
                'item': { 'codigo': '', 'nombre': '' },
                'filters': { 'codigo': 'codProveedor', 'nombre': 'nombreProveedor' },
                'resultName': 'dataRes',
                'request': {
                    'empresa': this.$store.getters.getAutenticacion.empresa,
                    'estado': 'A',
                    'conCompras': 'N'
                },
                'default': this.dSelectProveedor,
                'disabled': false,
                'required': false,
                'orderByDefault': 'codProveedor',
                'orderDefault': 'ASC',
                'isVisibleLoad': true,
                'textCodigo': 'codigo',
                'title': 'selectProveedor'
            }

            this.dDataSucursalProveedor = {
                'errorMessages': this.dErrorMsgProveedor,
                'label': 'sucursal',
                'rowsPerPage': 10,
                'headers': [
                    { text: this.$t('proveedor'), align: 'left', value: 'codigo', column: 'codProveedor' },
                    { text: this.$t('nombreProv'), align: 'left', value: 'nombre', column: 'nombreProveedor' }
                ],
                'urlWS': 'lovSucursalProveedor',
                'item': { 'codigo': '', 'nombre': '' },
                'filters': { 'codigo': 'codigoSucursal', 'nombre': 'razonSocial' },
                'resultName': 'dataRes',
                'request': {
                    'empresa': this.$store.getters.getAutenticacion.empresa,
                    'estado': 'A',
                    'conCompras': 'N',
                    'codigoProveedor': this.dSelectProveedor.codigo
                },
                'default': this.dSelectSucursalProveedor,
                'disabled': false,
                'required': false,
                'orderByDefault': 'codigoSucursal',
                'orderDefault': 'ASC',
                'isVisibleLoad': true,
                'textCodigo': 'codigo',
                'title': 'seleccionaUnaSucursal',
            }

            this.fCargarCentros()
        },
        fRespuestaCorrecta(response) {
            let finalValue = false;
            if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
                finalValue = true
            }
            return finalValue
        },
        fBuscar() {
            const auth = this.$store.getters.getAutenticacion;
            const isAdmin = this.dRole === 'ADMIN';
            const payload = {
                tira: auth.tira,
                usuario: auth.usuario,
                empresa: auth.empresa,
                codigoProveedor: isAdmin ? (this.dSelectProveedor.codigo || '') : auth.proveedor,
                codSucursal: isAdmin ? (this.dSelectSucursalProveedor.codigo || '') : auth.sucursalProv,
                fechaInicio: this.dDatosFiltros.fechaIniString || '',
                fechaFin: this.dDatosFiltros.fechaFinString || '',
                numeroOc: this.dDatosFiltros.numeroOc || '',
                centro: this.dDatosFiltros.centro || '',
                offset: this.dPaginationArt.rowsPerPage * (this.dPaginationArt.page - 1) + 1,
                numRows: this.dPaginationArt.rowsPerPage,
                orderBy: this.dPaginationArt.sortBy,
                order: this.dPaginationArt.descending ? 'DESC' : 'ASC'
            };
            this.dDatosTabla = [];
            this.dLoading = true;
            SrvOrdenesCompra.getOrdenesCompraPendientes(payload)
                .then((response) => {
                    if (!this.fRespuestaCorrecta(response)) {
                        this.$emit('alert', response.data.errorMsg.message || `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
                        return;
                    }
                    const datos = response.data.dataRes || [];
                    this.dDatosTabla = datos.map(item => ({
                        centro: item.centro || '-',
                        proveedor: item.razonProveedor || '-',
                        sucursal: item.razonSucursalProv || '-',
                        numeroOc: item.numeroOc || '-',
                        fechaOC: item.fechaOC ? this.$moment(item.fechaOC).format(this.dFormatDate.default) : '-',
                        numAlbaran: item.numAlbaran || '-',
                        numTicket: item.ticketPda || '-',
                        agenciaTransporte: item.agenciaTransporte || '-',
                        matricula: item.matricula || '-'
                    }));
                    this.dTotalItems = response.data.numReg;
                })
                .catch(() => {
                    this.$emit('alert', `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
                })
                .finally(() => {
                    this.dLoading = false;
                });
        },
        fGetDetalleOC(props) {
            props.expanded = !props.expanded;
            if (!props.expanded) {
                this.currentOrdenCompra = null;
                this.dSubOCDatosTabla = [];
                this.dTotalSubOCItems = 0;
                return;
            }

            this.currentOrdenCompra = props;
            this.dPaginationSubOC.page = 1;
            this.dFirstSortTableSubOC = 0;
            this.fCargaDetalle();
        },
        fCargaDetalle() {
            if (!this.currentOrdenCompra) {
                return;
            }
            this.dLoading = true;
            const payload = {
                "tira": this.$store.getters.getAutenticacion.tira,
                "empresa": this.$store.getters.getAutenticacion.empresa,
                "numeroOc": this.currentOrdenCompra.item.numeroOc,
                "offset": this.dPaginationSubOC.rowsPerPage * (this.dPaginationSubOC.page - 1) + 1,
                "numRows": this.dPaginationSubOC.rowsPerPage,
                "orderBy": this.dPaginationSubOC.sortBy,
                "order": this.dPaginationSubOC.descending ? 'DESC' : 'ASC'
            };
            SrvOrdenesCompra.getDetalleOrdenCompraPendiente(payload)
                .then(response => {
                    this.dLoading = false;
                    if (!this.fRespuestaCorrecta(response)) {
                        this.$emit(
                            'alert',
                            response.data.errorMsg.message ||
                            `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`
                        );
                        return;
                    }
                    this.dTotalSubOCItems = response.data.numReg || 0;
                    this.dSubOCDatosTabla = (response.data.dataRes || []).map(item => ({
                        "producto": item.producto,
                        "codigoLer": item.codigoLer ? item.codigoLer + ' - ' + item.denominacionLer : '-',
                        "cantidad": item.cantidad || 0,
                        "precioArt": item.precioArt || 0,
                        "importeLinea": item.importeLinea || 0,
                        "numeroDI": item.numeroDI || '-',
                        "descProducto": item.descProducto || '-',
                        "observacionesOC": item.observacionesOC || '-',
                        "itemOC": item.itemOC || '-',
                    }));

                })
                .catch(() => {
                    this.dLoading = false;
                    this.$emit('alert', `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
                });
        },
        fCambiaOrden(header, dPagination) {
            if (header.sortable) {
                const column = header.value
                dPagination.page = 1
                if (dPagination.sortBy === column) {
                    dPagination.descending = !dPagination.descending
                } else {
                    dPagination.sortBy = column
                    dPagination.descending = false
                }
            }
        },
        fAlert(msg) {
            this.$emit('alert', msg)
        },
        fCargarCentros() {
            const payload = {
                'empresa': this.$store.getters.getAutenticacion.empresa,
                'estado': 'A',
                'orderBy': 'centro'
            }

            SrvGeneral.lovCentro(payload).then((response) => {
                if (this.fRespuestaCorrecta(response)) {
                    this.dCentros = response.data.dataRes || []
                } else {
                    this.$emit('alert', response.data.errorMsg.message || `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
                }
            }).catch(error => {
                this.$emit('alert', `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
            })
        },
        fGetFecha(val, tipo) {
            switch (tipo) {
                case 'ini':
                    if (val) {
                        this.dDatosFiltros.fechaIniString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
                    }
                    else {
                        this.dDatosFiltros.fechaIniString = null;
                        this.dDatosFiltros.fechaIni = null;
                    }
                    this.dDatosFiltros.fechaIniMenu = false;
                    break;
                // 
                case 'fin':
                    if (val) {
                        this.dDatosFiltros.fechaFinString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
                    }
                    else {
                        this.dDatosFiltros.fechaFinString = null;
                        this.dDatosFiltros.fechaFin = null;
                    }
                    this.dDatosFiltros.fechaFinMenu = false;
            }
        },
        fDescargarXlsx() {
            this.dLoading = true;

            const auth = this.$store.getters.getAutenticacion;
            const payload = {
                "tira": auth.tira,
                "usuario": this.$store.getters.getAutenticacion.usuario,
                "empresa": this.$store.getters.getAutenticacion.empresa,
                "codigoProveedor": this.dRole === 'ADMIN' ? (this.dSelectProveedor.codigo || '') : this.$store.getters.getAutenticacion.proveedor,
                "codSucursal": this.dRole === 'ADMIN' ? (this.dSelectSucursalProveedor.codigo || '') : this.$store.getters.getAutenticacion.sucursalProv,
                "fechaInicio": this.dDatosFiltros.fechaIniString || '',
                "fechaFin": this.dDatosFiltros.fechaFinString || '',
                "numeroOc": this.dDatosFiltros.numeroOc || '',
                "centro": this.dDatosFiltros.centro || '',
                "descargaExcelSN": 'S',
                "orderBy": 'centro, codigoProveedor',
                "order": 'ASC'
            };

            SrvOrdenesCompra.getOrdenesCompraPendientes(payload).then((response) => {
                if (!this.fRespuestaCorrecta(response)) {
                    this.dLoading = false;
                    this.$emit('alert', response.data.errorMsg.message || `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
                    return;
                }

                try {
                    const workbook = XLSX.utils.book_new();
                    const allData = [];

                    const detalles = response.data.dataRes || [];
                    detalles.forEach(detalle => {
                        allData.push({
                            'Centro': detalle.centro,
                            'Cod Proveedor': detalle.codigoProveedor,
                            'Desc Proveedor': detalle.razonProveedor,
                            'Cod Sucursal': detalle.sucursalProveedor,
                            'Desc Sucursal': detalle.razonSucursalProv,
                            'Número OC': detalle.numeroOc,
                            'Item OC': detalle.itemOC,
                            'Fecha OC': detalle.fechaOC ? this.$moment(detalle.fechaOC, 'DD/MM/YY').format(this.dFormatDate.default) : undefined,
                            'Número Albarán': detalle.numAlbaran,
                            'Ticket PDA': detalle.ticketPda,
                            'Agencia Transporte': detalle.agenciaTransporte,
                            'Matrícula': detalle.matricula,
                            'Producto': detalle.producto,
                            'Desc Producto': detalle.descProducto,
                            'Código LER': detalle.codigoLer,
                            'Desc LER': detalle.denominacionLer,
                            'Cantidad': detalle.cantidad,
                            'Precio Artículo': detalle.precioArt,
                            'Importe Línea': detalle.importeLinea,
                            'Observaciones OC': detalle.observacionesOC,
                            'Número DI': detalle.numeroDI,

                        });
                    });

                    const worksheet = XLSX.utils.json_to_sheet(allData);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'RecogidasEntregas');
                    XLSX.writeFile(workbook, 'ordenesCompraPendientes.xlsx');
                    this.dLoading = false;
                } catch (err) {
                    this.dLoading = false;
                    this.$emit('alert', `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
                }
            }).catch(error => {
                this.dLoading = false;
                this.$emit('alert', `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`);
            });
        },
    }, watch: {
        dPaginationArt: {
            handler(newPage, oldPage) {
                if (this.dFirstSortTable > 0) {
                    this.fBuscar()
                }
                this.dFirstSortTable++
            },
            deep: true
        },
        dPaginationSubOC: {
            handler(newPage, oldPage) {
                if (!this.currentOrdenCompra) {
                    return;
                }
                if (newPage === oldPage) {
                    return;
                }
                this.dFirstSortTableSubOC++;
                if (this.dFirstSortTableSubOC > 0) {
                    this.fCargaDetalle();
                }
            },
            deep: true
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/OCPendientes/ShpOCPendientes.vue